import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions('cart', ['removeCartItem']),

    remove(item_id) {
      this.loading = true;

      this.removeCartItem({ id: item_id })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
